import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import CenterInfo from 'view/centerInfo';

const CenterManagePage = () => {
	return (
		<PageTemplate>
			<CenterInfo />
		</PageTemplate>
	);
};

export default CenterManagePage;

 